import React, { Component } from "react";
import { StyleSheet, View } from "react-native";

import * as x from "styles/css";

class StatusBar extends Component {
	render() {
		return (
			<View  />
		);
	}
}

export default StatusBar;



// WEBPACK FOOTER //
// ./src/components/StatusBar/index.web.js